import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import { arTranslations } from './languages/ar';
import { enTranslations } from './languages/en';

i18n.use(initReactI18next).init({
  fallbackLng: 'ar',
  debug: true,
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
});

export default i18n;
